import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseTableComponent } from '../base-table/base-table.component';
import { Product } from 'src/app/entities/product';
import { ProductService } from 'src/app/services/product.service';
import { AlertService } from 'src/app/services/alert.service';
import { fuseAnimations } from '@mobileia/layout-fuse';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class ProductComponent extends BaseTableComponent<Product> implements OnInit {

  displayedColumns = ['id', 'external_code', 'category', 'title', 'is_feature', 'status', 'actions'];
  configColumns = [
    {
      key: 'id',
      field_key: 'id',
      type: 'integer',
      title: 'ID',
      classes: 'font-weight-600'
    },
    {
      key: 'external_code',
      field_key: 'external_code',
      type: 'string',
      title: 'Código',
      classes: ''
    },
    {
      key: 'title',
      field_key: 'title',
      type: 'string',
      title: 'Titulo',
      classes: ''
    },
    {
      key: 'is_feature',
      field_key: 'is_feature',
      type: 'option',
      title: 'Destacado',
      classes: '',
      options: {
        '0': {
          title: 'NO'
        },
        '1': {
          title: 'SI'
        },
      }
    },
    {
      key: 'status',
      field_key: 'status',
      type: 'option',
      title: 'Visible',
      classes: '',
      options: {
        '0': {
          title: 'Desactivado'
        },
        '1': {
          title: 'Activo'
        },
      }
    },
  ];

  constructor(
    protected productService: ProductService,
    protected alertService: AlertService
  ) {
    super(alertService);
    this.service = productService;
  }

  ngOnInit(): void {
    this.tableModel.addWhere('product_child.stock', 105);
    this.loadItems();
  }

  onSearch() {
    if (this.filterSearch != '') {
      this.tableModel.addwhereLike('product.title', this.filterSearch);
    } else if(this.filterSearch == "" && this.filterSearchCodigo == ""){
      this.tableModel.resetWhere();
    }else if(this.filterSearchCodigo != ""){
      this.tableModel.addwhereLike('product.external_code', this.filterSearchCodigo);
    }
    this.tableModel.addWhere('product_child.stock', 105);
    this.loadItems();
  }
}
